var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-overlay",class:[_vm.classes],style:([_vm.styles])},[_c('div',{staticClass:"v-overlay-scrim",style:([_vm.screamStyles])}),(_vm.value)?_c('div',{staticClass:"v-overlay-content"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }